<app-alert-modal
  (confirmed)="confirmNftOffer()"
  #nftUnlockOffer
  [headerLabel]="modalHeader"
  dynamicClass="nft-unlock-modal-container"
  (canceled)="handleCancel()"
  [modalOptions]="modalOptions"
>
  <div class="d-flex flex-column c-gap-30 text-left">
    <div class="modal-header-label">
      {{
        messages.UNLOCK_OFFER_BUY_NFT.replace(
          '[content]',
          (headerType || contentType).toUpperCase()
        )
      }}
    </div>
    <div>
      <div class="modal-header-label-bold">
        {{ messages.FOLLOW_STEP_TO_UNLOCK_NFT }}:
      </div>
      <ol class="mt-4">
        <li class="list-item">{{ messages.USE_CHROME_DESKTOP_BROWSER }}</li>
        <li class="list-item">
          {{ messages.INSTALL_METAMASK_PLUGIN }}
          <a [href]="metaMaskUrl">{{ metaMaskUrl }}</a>
        </li>
        <li class="list-item">
          {{ messages.LOGIN_WALLET_CHOOSE_NFT }}
        </li>
        <li class="list-item">
          {{ messages.GO_TO_EDIT_PREF_NFT_WALLET }}
        </li>
      </ol>
    </div>
  </div>
</app-alert-modal>
